import { useCallback } from "react";
import { EnumSmartFeedActivity, useFeedActivityMutation } from "src/api/client/feed-activity.api";
import { feedTrackingStore } from "src/components/feed-card/store/feed-tracking-store";

export enum EnumFeedClickTrackingArea {
    Header = "header",
    Body = "body",
    Footer = "footer",
    Actor = "actor",
}

export enum EnumFeedClickTrackingType {
    Link = "link",
    Button = "button",
    Preview = "preview",
}

export const useFeedClickTracking = () => {
    const feedActivityMutatePromise = useFeedActivityMutation();

    const trackFeedClick = useCallback(
        (itemId: string, url: string, area: EnumFeedClickTrackingArea, type: EnumFeedClickTrackingType = EnumFeedClickTrackingType.Link) =>
            feedActivityMutatePromise({
                itemId,
                type: EnumSmartFeedActivity.SmartFeedItemClicked,
                parameter: JSON.stringify({
                    area,
                    type,
                    targetUrl: url,
                    feedType: feedTrackingStore.feedType,
                    page: feedTrackingStore.page,
                    wikifolioId: feedTrackingStore.wikifolioId,
                }),
            }),
        [feedActivityMutatePromise]
    );

    return { trackFeedClick };
};
